import React from 'react'
import { isMobile, isDesktop, isIpad } from '../../../global/ScreenSizeHelper'



const Catering = (props) => {
    const { filteredCateringList, handleClickRedirect } = props
    // console.log('----Catering', filteredCateringList)
    return (
        <div>Catering</div>
    )
}

export default Catering